export enum FeatureName {
  MAINTENANCE = 'maintenance',
  RARITIES_WITH_ORACLE = 'rarities-with-oracle'
}
